<mat-dialog-content>
  <zxing-scanner
    [formats]="formatsEnabled"
    (camerasFound)="onCamerasFound($event)"
    (camerasNotFound)="onCamerasNotFound()"
    (scanComplete)="onScanComplete($event)"
    (scanSuccess)="onScan($event)"
  ></zxing-scanner>
  @if (hasNoCamera) {
    <div class="no-camera-message">
      <p>{{ 'scan.noCameraFound' | translate }}.</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (devices.length > 1) {
    <button
      (click)="onSwitchDevice()"
      mat-icon-button
      title="switch camera"
    >
      <mat-icon>autorenew</mat-icon>
    </button>
  }
  <button mat-button mat-dialog-close>
    {{ 'scan.fermer' | translate }}
  </button>
</mat-dialog-actions>
